import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {getRamblerIdHelper} from '@rambler-id/helper'
import {Avatar, IconButton, ClearIcon} from 'rambler-ui'
import Popup from 'components/Popup'
import withAvatars from 'models/avatars'
import styles from './styles.css'
import cn from 'classnames'
import {isMobileOrTabletDevice} from 'utils/isMobileOrTabletDevice'

class Avatars extends PureComponent {
  static propTypes = {
    avatars: PropTypes.array,
    activeAvatarSrc: PropTypes.string,
    uploadAvatar: PropTypes.func.isRequired,
    deleteAvatar: PropTypes.func.isRequired,
    activateAvatar: PropTypes.func.isRequired,
    resetAvatar: PropTypes.func.isRequired
  }

  async UNSAFE_componentWillReceiveProps({activeAvatarSrc, onResolve}) {
    if (activeAvatarSrc !== this.props.activeAvatarSrc) {
      // emit login to reload topline
      const ramblerIdHelper = await getRamblerIdHelper()

      ramblerIdHelper.emit('login')
      onResolve()
    }
  }

  render() {
    const {
      avatars,
      activeAvatarSrc,
      uploadAvatar,
      deleteAvatar,
      activateAvatar,
      resetAvatar,
      ...props
    } = this.props

    return (
      <Popup {...props} title="Обновить фото в профиле">
        <div className={styles.root}>
          {avatars.length > 0 && (
            <div className={styles.group}>
              Ваши фото
              <div className={styles.list}>
                {avatars.map(({id, key, isActive}) => (
                  <div key={id} className={styles.item}>
                    <Avatar
                      className={isActive ? '' : styles.avatar}
                      size={48}
                      src={`//avatars.rambler.ru/get${key}`}
                      onClick={isActive ? null : () => activateAvatar(id)}
                    />
                    <IconButton
                      size={20}
                      className={cn(
                        styles.delete,
                        isMobileOrTabletDevice && styles.visible
                      )}
                      aria-label="Удалить фото"
                      data-cerber-id="profile::avatar::delete_avatar"
                      onClick={() => deleteAvatar(id)}>
                      <ClearIcon size={11} />
                    </IconButton>
                  </div>
                ))}
              </div>
            </div>
          )}
          {avatars.length < 5 && (
            <label
              className={styles.button}
              htmlFor="uploadMoreImage"
              data-cerber-id="profile::avatar::upload_avatar">
              Загрузить фото
              <input
                type="file"
                tabIndex="0"
                id="uploadMoreImage"
                onChange={uploadAvatar}
                accept="image/bmp,image/jpeg,image/png"
              />
            </label>
          )}
          {/get\/(.+)\/default/.test(activeAvatarSrc) === false && (
            <button
              type="button"
              className={styles.button}
              tabIndex="0"
              onClick={resetAvatar}
              data-cerber-id="profile::avatar::without">
              Без фото
            </button>
          )}
        </div>
      </Popup>
    )
  }
}

export default withAvatars(Avatars)
